<template>
  <div class="addOne">
      <header>
          <div class="headerOne" >
              <img src="../../assets/images/returnOne.png" @click="$router.go(-1)">  
          </div>
            <span class="myOne">订单详情</span>
    </header>
    <div class="bussOne">
        <img src="../../assets/images/logoName.png">
    </div>
    <div class="trade">优衣库-宝龙程店</div>
    <div class="allOne">
        <div>
            <span>支付单号 :</span>
            <span>123456789012345678901234567890</span>
       </div>
        <div>
        <div>
            <span>消费内容 :</span>
            <span>婴幼儿紧身打底裤</span>
        </div>
        <div>
            <span>折扣 :</span>
             <span>7折</span>
        </div>
        <div >
            <span>应付金额 :</span>
            <span>154.50</span>
        </div>
        <div class="bogTwo">
            <span>实付金额 :</span>
            <span>￥108.00</span>
        </div>
        <div class="bigTgree">
            <span>支付密码</span>
             <input type="password" >
        </div>
    </div>
    </div>
      <div class="sub" @click="sucessMod">
                完成
          </div>
  </div>
</template>
<script>
    export default{
        data(){
            return{
               
            }
        },
        methods:{
            sucessMod(){
                
            }
        }
    }
</script>
<style scoped>
header{
    height:1rem;
    width: 100%;
    position: relative;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06)
}
 .headerOne{
     font-size: 0;  
     width: 20%;
     
     }
 .headerOne img{
    display: inline-block;
    margin-top: 0.3rem;
    
 }
  .headerOne img:nth-child(1){
      margin-left: 0.2rem
  }
  .myOne{
      font-size: 0.35rem;
      position: absolute;
      top: 0.25rem;
      left:3rem;
      }
       .bussOne {
           margin-top: 0.2rem
       }
  .bussOne img{
      display: block;
      margin: 0 auto
  }
.trade{
    text-align: center;
    font-size: 0.3rem;
    color: #000000;
    margin-top: 0.2rem
}
.allOne{
    color: rgba(0, 0, 0, 0.52);
    font-size: 0.3rem;
    margin-left: 0.35rem;
    margin-top: 0.35rem
}
.allOne div{
    margin-bottom: 0.2rem
}
.bogTwo{
    margin-top: 0.25rem
}
.bogTwo span{
  font-size: 0.38rem;
  font-weight: 550
}
.bogTwo span:nth-child(2){
    color: #000000;
    font-size: 0.4rem
}
.bigTgree{
    font-size: 0.35rem;
    color: rgba(0, 0, 0, .9);
    margin-top: 0.1rem
}
.bigTgree span{
    vertical-align: middle;
}
.bigTgree input{
    outline: none;
    border: none;
    border-bottom: 1px solid rgba(0, 0, 0, .2);
    padding-top: 0.2rem;
    vertical-align: middle;
    margin-left: 0.2rem
}
 .sub {
        color: white;
      font-size: 0.4rem;
      width: 90%;
      background-image: linear-gradient(to right, #2EA4B0, #06789D);
      margin: 0 auto;
      margin-top: 0.5rem;
      height: 1rem;
      border-radius: 15px;
      text-align: center;
      line-height: 1rem
    }
</style>



// WEBPACK FOOTER //
// src/components/conuccess/conuccess.vue